
import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class MonacoEditor extends Vue {
  @Prop({ default: "" }) value!: string; // <-- v-model uses 'value'
  @Prop({ default: "python" }) language!: string;
  @Prop({ default: "vs-dark" }) theme!: string;
  @Prop({ default: false }) disabled!: boolean;

  editor: any = null;

  mounted() {
    if (process.client) {
      // Load Monaco from CDN to bypass Webpack 4 build issues (import.meta in ESM, require in AMD)
      const loadMonaco = () => {
        return new Promise((resolve, reject) => {
          if ((window as any).monaco) return resolve((window as any).monaco);

          const script = document.createElement("script");
          script.src = "https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.34.1/min/vs/loader.min.js";
          script.async = true;
          script.onload = () => {
            const require = (window as any).require;
            require.config({ paths: { vs: "https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.34.1/min/vs" } });
            require(["vs/editor/editor.main"], (monaco) => resolve(monaco));
          };
          script.onerror = reject;
          document.body.appendChild(script);
        });
      };

      loadMonaco().then((monaco: any) => {
        const container = this.$refs.editorContainer as HTMLElement;
        if (!container) return;
        
        try {
          this.editor = monaco.editor?.create(container, {
            value: this.value,
            language: this.language,
            theme: this.theme,
            readOnly: this.disabled,
            automaticLayout: true,
          });

          // Emit input event on content change
          this.editor.onDidChangeModelContent(() => {
            const newValue = this.editor.getValue();
            this.$emit("input", newValue); // v-model-compatible
          });
          this.$emit("editor-mounted", this.editor, monaco);
        } catch (error) {
          console.error('Monaco editor failed to initialize:', error);
        }
      }).catch((error) => {
        console.error('Monaco editor module failed to load:', error);
      });
    }
  }

  @Watch("value")
  onValueChanged(newVal: string) {
    if (this.editor && this.editor.getValue() !== newVal) {
      this.editor.setValue(newVal);
    }
  }

  beforeDestroy() {
    if (this.editor) {
      this.editor.dispose();
    }
  }
}
